import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { LegacyApiResponse, unwrapLegacyResult } from '../../../shared/utils/legacy-api-response.util';
import { unwrapV2, V2ApiResponse } from '../../../shared/utils/v2-api-response.util';
import { CashEntity, CashPayload } from '../models/cash-form.model';

@Injectable({ providedIn: 'root' })
export class CashCrudService {
  private readonly baseUrl = `${environment.apiUrl}/efectivo`;

  constructor(private http: HttpClient) { }

  get(uid: string): Promise<CashEntity> {
    return unwrapV2(
      firstValueFrom(this.http.get<V2ApiResponse<CashEntity>>(`${environment.apiUrl}/api/v2/cashs/${encodeURIComponent(uid)}`)),
      'No se pudo cargar la caja'
    );
  }

  create(payload: CashPayload): Promise<void> {
    return firstValueFrom(this.http.post<LegacyApiResponse<any>>(this.baseUrl, payload))
      .then(response => { unwrapLegacyResult(response, 'Ha ocurrido un error inesperado al crear la caja'); });
  }

  update(uid: string, payload: CashPayload): Promise<void> {
    return firstValueFrom(this.http.put<LegacyApiResponse<boolean>>(this.baseUrl, { ...payload, uid }))
      .then(response => { unwrapLegacyResult(response, 'Ha ocurrido un error inesperado al actualizar la caja'); });
  }
}
